module.exports = __webpack_public_path__ + "img/129.3003-Silber Platin.jpg";